(ns frontend.ui.component.lp-portal.voima-components.section.view
  (:require
   [frontend.ui.component.lp-portal.voima-components.section.style :as style]
   [herb.core :refer [<class]]))

(defn section
  [title id & children]
  [:div
   (merge {:class (<class style/section)}
          (when id
            {:id id}))
   [:div
    {:class (<class style/header)}
    title]
   (into [:div
          {:class (<class style/content)}]
         children)])

(defn portfolio-section
  [title id & children]
  [:div
   (merge {:class (<class style/section)}
          (when id
            {:id id}))
   [:div
    {:class (<class style/portfolio-header)}
    title]
   (into [:div
          {:class (<class style/content)}]
         children)])

(defn wrapped-section
  [title id & children]
  [:div
   (merge {:class (<class style/section)}
          (when id
            {:id id}))
   [:div
    {:class (<class style/header-alternative)}
    title]
   (into [:div
          {:class (<class style/content)}]
         children)])

(defn sections-wrapper
  [children]
  [:div
   (into [:div] children)])
